import { Theme } from '@mui/material/styles';

export const box = (theme: Theme) => ({
    [theme.breakpoints.up('lg')]: {
        marginRight: theme.spacing(40),
    },
}) as const;

export const emailCaption = (theme: Theme) => ({
    display: 'flex',
    marginTop: theme.spacing(-0.5),
    color: 'text.secondary',
}) as const;

export const caption = (theme: Theme) => ({
    marginTop: theme.spacing(2),
}) as const;
